export const chart_theme_multi_color_unordered_ColorScale_1800 = {
  "name": "--pf-v6-chart-theme--multi-color-unordered--ColorScale--1800",
  "value": "#b6a6e9",
  "var": "var(--pf-v6-chart-theme--multi-color-unordered--ColorScale--1800, #b6a6e9)"
};
export default chart_theme_multi_color_unordered_ColorScale_1800;